import React, { useState } from 'react';
import { updateUserAttributes } from 'aws-amplify/auth';

function ReminderPopup({ voornaam, onClose }) {
  const [bezig, setBezig] = useState(false);

  const handleActiveer = async () => {
    setBezig(true);
    try {
      await updateUserAttributes({
        userAttributes: { 'custom:monthly_reminder': 'true' }
      });
    } catch {}
    onClose(true);
  };

  const handleNee = () => {
    sessionStorage.setItem('reminderPopupDismissed', '1');
    onClose(false);
  };

  const aanhef = voornaam ? `Hoi ${voornaam}!` : 'Hoi!';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center">
            <svg className="w-7 h-7 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">{aanhef}</h2>
            <p className="text-gray-600 mt-2 text-sm leading-relaxed">
              Wil je elke <strong>eerste maandag van de maand</strong> een herinnering ontvangen om je reiskosten te declareren in AFAS?
            </p>
            <p className="text-xs text-gray-400 mt-1">Je kunt dit altijd aan- of uitzetten via je profiel.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full pt-2">
            <button
              onClick={handleActiveer}
              disabled={bezig}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-xl transition disabled:opacity-50"
            >
              {bezig ? 'Activeren...' : 'Ja, activeer!'}
            </button>
            <button
              onClick={handleNee}
              disabled={bezig}
              className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-xl transition"
            >
              Nee, bedankt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderPopup;
